export const SET_MSG = "SET_MSG";
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FINISH = "AUTH_FINISH";
export const AUTH_FAILED = "AUTH_FAILED";

export function authStart() {
    return {
        type: AUTH_START
    };
}

export function authFinish() {
    return {
        type: AUTH_FINISH
    };
}

export function authFailed(errorCode = null, failedLogIn = false) {
    return {
        type: AUTH_FAILED,
        errorCode,
        failedLogIn
    };
}

export function setMsg(msg, severity, errorCode = null, isFatal = false) {
    return {
        type: SET_MSG,
        msg,
        severity,
        errorCode,
        isFatal
    };
}
